module.exports = __webpack_public_path__ + "fonts/FangZhengHeiTiJianTi-1.cafa69cd.ttf";